import o from "./ghl-ui.es1505.js";
import i from "./ghl-ui.es1506.js";
import m from "./ghl-ui.es1466.js";
function s(e, t) {
  m(2, arguments);
  var r = i(e), a = o(t);
  return isNaN(r.getTime()) ? /* @__PURE__ */ new Date(NaN) : (r.setFullYear(a), r);
}
export {
  s as default
};
